module.exports = __webpack_public_path__ + "static/media/ye.593b8c90.svg";